$(document).ready(function() {
  var link = "https://api.tumblr.com/v2/blog/bingbangnyc.tumblr.com/posts/photo?tag=muse+featured&limit=1";
    $.ajax({
        type: "GET",
        url: link,
        dataType: "jsonp",
        data: {
            api_key: "ClAjag2DrKwJhbFY1aAAwqBUxEFBEOBwc7AzMwXlcaNlp3gZte"
        }
    }).done(function (data) {

    var url = data.response.posts[0];
    imageUrl = url.photos[0].original_size.url;
    // Find img with tumblr data atribute
    var imageDataString = 'img[data-tumblr-image]';
    // Get DOM element for the img
    var imageItem = $(imageDataString)[0];
    imageItem.src = imageUrl;

    });
});

$(document).ready(function() {
  var link2 = "https://api.tumblr.com/v2/blog/bingbangnyc.tumblr.com/posts/photo?tag=moodboard+featured&limit=1";
    $.ajax({
        type: "GET",
        url: link2,
        dataType: "jsonp",
        data: {
            api_key: "ClAjag2DrKwJhbFY1aAAwqBUxEFBEOBwc7AzMwXlcaNlp3gZte"
        }
    }).done(function (data) {

      var url = data.response.posts[0];
      imageUrl = url.photos[0].original_size.url;
      // Find img with tumblr data atribute
      var imageDataString = 'img[data-tumblr-image-2]';
      // Get DOM element for the img
      var imageItem = $(imageDataString)[0];
      imageItem.src = imageUrl;

    });
});

$(document).ready(function() {
  var link3 = "https://api.tumblr.com/v2/blog/bingbangnyc.tumblr.com/posts/photo?tag=bingbangbabe+featured&limit=1";
    $.ajax({
        type: "GET",
        url: link3,
        dataType: "jsonp",
        data: {
            api_key: "ClAjag2DrKwJhbFY1aAAwqBUxEFBEOBwc7AzMwXlcaNlp3gZte"
        }
    }).done(function (data) {

      var url = data.response.posts[0];
      imageUrl = url.photos[0].original_size.url;
      // Find img with tumblr data atribute
      var imageDataString = 'img[data-tumblr-image-3]';
      // Get DOM element for the img
      var imageItem = $(imageDataString)[0];
      imageItem.src = imageUrl;

    });
});
